<!-- Lightweight number animation component -->
<script setup lang="ts">
import { useTransition } from '@vueuse/core'
import { ref } from 'vue'

const props = defineProps<{
  value: number
}>()

const source = ref(0)
const displayValue = useTransition(source, {
  duration: 1500,
})
source.value = Math.round(props.value)
</script>

<template>
  <span>{{ displayValue.toFixed(0) }}</span>
</template>
